<script>
import ApiErrorMixin from '@/mixins/apiErrorMixin'
import { formatDate } from '@/utils/date-util'

import {
  BLACK_LIST_LEVEL_ORGANIZATION,
  BLACK_LIST_LEVEL_ORGANIZATION_LABEL,
  BLACK_LIST_LEVEL_OFFICE_LABEL,
  BLACK_LIST_LEVEL_LEGAL_ENTITY_LABEL,
  BLACK_LIST_LEVEL_OFFICE,
  BLACK_LIST_LEVEL_SYSTEM,
  BLACK_LIST_LEVEL_SYSTEM_LABEL,
  BLACK_LIST_LEVEL_LEGAL_ENTITY_LEVEL,
} from '@/components/common/filter/black-list-level'


export default {
  name: 'BlackListMixin',
  mixins: [ApiErrorMixin],
  data () {
    return {
      paginatorTotal: 0,
      loading: true,
      modelList: [],
      blackListFilterSet: {
        level: null,
        office: null,
        vacancy: null,
        organization: null,
        user: null,
        expiredAt: null,
        editMode: null,
      },
    }
  },
  computed: {
  },
  methods: {
    getRequestParams () {
      const { user, office, organization, vacancy, level, expiredAt } = this.blackListFilterSet

      const model = {
        level,
        expiredAt,
        'organization[id]': undefined,
        'office[id]': undefined,
        'user[id]': undefined,
        'vacancy[id]': undefined
      }

      if (user) {
        model['user[id]'] = user.id
      }
      if (office) {
        model['office[id]'] = office.id
      }
      if (organization) {
        model['organization[id]'] = organization.id
      }
      if (vacancy) {
        model['vacancy[id]'] = vacancy.id
      }
      return model
    },
    getLevelTrans (status) {
      switch (status) {
      case BLACK_LIST_LEVEL_LEGAL_ENTITY_LEVEL:
        return BLACK_LIST_LEVEL_LEGAL_ENTITY_LABEL
      case BLACK_LIST_LEVEL_ORGANIZATION:
        return BLACK_LIST_LEVEL_ORGANIZATION_LABEL
      case BLACK_LIST_LEVEL_OFFICE:
        return BLACK_LIST_LEVEL_OFFICE_LABEL
      case BLACK_LIST_LEVEL_SYSTEM:
        return BLACK_LIST_LEVEL_SYSTEM_LABEL
      }
    },
    async requestList (page, size, setModelListCallback, setPaginationCallBack) {
      this.showPageLoader()
      // this.tableLoading = true
      try {
        this.loading = true
        this.modelList = []
        const params = {
          ...this.getRequestParams(),
          'page[number]': page || this.options.page,
          'page[size]': size || this.options.itemsPerPage
        }

        const response = await this.$store.dispatch(
          'user/getBlackListEntryList',
          { params }
        )
        this.modelList = response.data.map((item) => ({
          ...item,
          dateString: formatDate(item.createdAt),
          levelRu: item.trustabilityPenaltyType ? 'Отклик' : this.getLevelTrans(item.level),
          expiredAtString: item.expiredAt ? formatDate(item.expiredAt) : null,
        }))

        if (response.headers['x-total-count']) {
          this.paginatorTotal = parseInt(response.headers['x-total-count'], 10)
        } else {
          this.paginatorTotal = this.footerProps.itemsPerPageOptions[1]
        }

        this.loading = false
        this.hidePageLoader()
      } catch (error) {
        console.log(error)
        this.loading = false
        this.hidePageLoader()
      }
    },
    async createBlackListEntry () {
      await this.proceedCreate(this.blackListFilterSet)
    },
    async proceedCreate (blackListFilterSet, saveCallback) {
      const {
        user,
        office,
        organization,
        vacancy,
        level,
        expiredAt,
        duration,
        description,
        relay,
        legalEntity
      } = blackListFilterSet

      const model = {
        level,
        description,
        expiredAt,
        duration,
        'organization': undefined,
        'office': undefined,
        'user': undefined,
        'legalEntity': undefined,
        'vacancy': undefined
      }

      if (relay) {
        model.relay = { id: relay }
      }
      if (user) {
        model.user = { id: user }
      }
      if (office) {
        model.office = { id: office }
      }
      if (organization) {
        model.organization = { id: organization }
      }
      if (vacancy) {
        model.vacancy = { id: vacancy }
      }
      if (legalEntity) {
        model.legalEntity = { id: legalEntity }
      }

      try {
        this.showPageLoader()

        const response = await this.$store.dispatch(
          'user/addToBlackList',
          model
        )
        this.hidePageLoader()
        if (saveCallback) {
          saveCallback()
        }
        this.showSuccessNotification('Пользователь успешно добавлен в черный список', 'success')
        return response
      } catch (error) {
        this.showErrorNotification('Ошибка при добавлении пользователя в черный список', 'error')
        this.hidePageLoader()
      }
    },
    async deleteBlackListEntry (item, saveCallback) {
      try {
        this.showPageLoader()

        await this.$store.dispatch(
          'user/unBlockUser',
          { id: item.id, description: item.description }
        )
        this.hidePageLoader()
        if (saveCallback) {
          saveCallback()
        }
        this.showSuccessNotification('Пользователь успешно разблокирован!', 'success')
      } catch (error) {
        console.log(error)
        this.hidePageLoader()
        this.showErrorNotification('Не удалось разблокировать пользователя', 'error')
      }
    }
  }
}

</script>
